<template>
  <section class="bdg-calendar-view">
    <div class="column-headers flex">
      <div class="crew-identifier">Crew</div>
      <div
        class="flex-1 flex flex-col justify-center text-center cal-cell"
        :class="{ today: isDateToday(day) }"
        v-for="(day, key) in selectedWeekDays"
        :key="key"
      >
        <div class="uppercase">{{ day | moment("ddd") }}</div>
        <div>{{ day | moment("D") }}</div>
      </div>
    </div>
    <template v-if="weeklyCrewView && weeklyCrewView.length > 0">
      <div
        class="data-cells flex items-start items-stretch crew-row"
        v-for="(crew, key) in weeklyCrewView"
        :key="key"
      >
        <div class="crew-identifier">
          {{ crew.identifier }}
        </div>
        <item
          :id="day"
          class="flex-1 cal-cell"
          :day="day"
          :crew="crew"
          v-for="(day, i) in selectedWeekDays"
          :key="`crew_${crew.id}_${i}`"
        />
      </div>
    </template>
    <div class="empty-state" v-else>
      You don't have any crews!
    </div>
  </section>
</template>

<script>
import { mapGetters } from "vuex";
import item from "./BdgCalendarViewItem";

export default {
  name: "BdgCalendarView",
  //Pass in data//
  components: { item },
  computed: {
    ...mapGetters(["weeklyCrewView", "selectedWeekDays"])
  },
  methods: {
    isDateToday(date) {
      return this.$moment().isSame(date, "day");
    }
  }
};
</script>

<style lang="scss" scoped>
section.bdg-calendar-view {
  .column-headers,
  .data-cells {
    .crew-identifier {
      @apply flex-1 flex flex-col justify-center border-b border-lightgray p-4 text-center;
    }
  }
  .cal-cell {
    border-left: 1px solid #c2c2c2;

    @apply border-b border-lightgray;

    &.today {
      @apply bg-lightgray-lighter;
    }
  }
  .item {
    border-radius: 5px;
    background-color: #b3282d;
    color: white;
    padding: 3px;
  }
  .crew-row {
    background-color: white;
    &:nth-child(even) {
      background: #eee;
    }
  }

  .empty-state {
    @apply flex justify-center border border-0 border-t border-lightgray p-8;
  }
}
</style>
